/* eslint-disable max-len */
import { useContext, useEffect, useMemo, useState } from "react";
import { useScreenClass } from "react-grid-system";
import styled from "styled-components";
import Button from "../../components/Button";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import NormalIcon from "../../components/Icon";
import { Icon } from "@mui/material";
import { StyledText, TextSize, TextStatus } from "../../components/Text";
import Card from "../../components/Card";
import {
  LocationInterface,
  RightAlign,
} from "../../components/UtilsComponents";
import ALink from "../../components/ALink";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { UserContext } from "../../context/UserContext";
import { SemesterContext } from "../../context/SemesterContext";
import defaultImg from "../../assets/DefaultCardImage.png";
import { EmptyMilestoneType, MilestoneType } from "../../types/Milestone";
import Status from "../../types/enum/Status";
import { handleJWTError } from "../../hooks/jwtErrHandler";
import { UniversityContext } from "../../context/UniversityContext";

interface Props {
  selectedCompetency: any;
  setIsModalOpen: any;
  stuId: string;
  tab?: number;
}
type BlockProps = {
  backgroundColor: string;
};
const StyledButton = styled(Button)`
  background: rgba(255, 255, 255, 0.33);
  /* Other/Border */

  border: 1px solid #e7ebee;
  box-sizing: border-box;
  backdrop-filter: blur(33px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 6px;
  &:hover:not(:disabled){
    background-color: rgba(255, 255, 255, 0.33);
    -webkit-text-decoration: none;
    text-decoration: none;
    color: #E5E5E5;
  },
`;
const SkillCompleted = styled(Card)`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;

  position: static;
  width: auto;
  height: auto;
  left: 0px;
  top: 0px;

  /* Dark outline transparent */

  background: rgba(0, 0, 0, 0.3);
  border: 2px solid #36eab9;
  box-shadow: 0px 4px 35px #54c2ab;
  backdrop-filter: blur(40px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 10px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 20px;
  cursor: pointer;
`;
const SkillOptional = styled(Card)`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;

  position: static;
  width: auto;
  height: 186px;
  left: 0px;
  top: 0px;

  background: #191b34;
  backdrop-filter: blur(40px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 10px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 20px;
  cursor: pointer;
`;
const CustomBlock = styled(FlexGrow)<BlockProps>`
  margin-bottom: 16px;
  text-align: center;
  background: ${({ backgroundColor }) => backgroundColor};
  padding: 16px;
  flex-grow: 0;
  position: relative;
  cursor: pointer;
  width: 171px;
  min-width: 171px;
  max-width: 171px;
  height: 270px;
  min-height: 270px;
  max-height: 270px;
  overflow: hidden;
  border-radius: 12px;
  //   :after {
  //     border-bottom: 20px solid transparent;
  //     border-left: 20px solid transparent;
  //     // border-right: 20px solid;
  //     // border-image-source: ${({ backgroundColor }) => backgroundColor};
  //     // border-color: ${({ backgroundColor }) => backgroundColor};
  //     content: '';
  //     height: 0;
  //     position: absolute;
  //     top: 11px;
  //     width: 0;
  //     right: 2px;
  //     transform: rotate(45deg);
  // }
  //   }
  //   :before {
  //     border-bottom: 20px solid transparent;
  //     border-left: 20px solid;
  //     border-image-source: ${({ backgroundColor }) => backgroundColor};
  //     border-color: ${({ backgroundColor }) => backgroundColor};
  //     border-right: 20px solid transparent;
  //     content: '';
  //     height: 0;
  //     position: absolute;
  //     top: 11px;
  //     width: 0;
  //     left: 2px;
  //     transform: rotate(312deg);
  //   }
`;
const StyledHr = styled.hr`
  width: 96%;
  border-color: #3c406c;
  margin-top: 16px;
  margin-bottom: 16px;
`;
const StyledImg = styled.img`
  width: 100%;
  height: 65%;
  max-height: 65%;
  min-height: 65%;
  margin-bottom: 10px;
  border-radius: 7px;
`;
function CompetencyDetail(props: Props) {
  const navigate = useNavigate();
  const screenClass = useScreenClass();
  let location = useLocation() as LocationInterface;
  const stateData = location.state;
  const [searchParams] = useSearchParams();
  const [milestoneId, setMilestoneId] = useState(searchParams.get("mid"));
  const userContext = useContext(UserContext);
  const currentUser = userContext.user;
  const [milestone, setMilestone] = useState<MilestoneType>(EmptyMilestoneType);
  const [competencyDetail, setCompetencyDetail] = useState<any>({
    semesterDetail: { instructors: "" },
  });
  const semesterContext = useContext(SemesterContext);
  const universityContext = useContext(UniversityContext);
  const { selectedCompetency, setIsModalOpen, stuId, tab } = props;
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass],
  );

  useEffect(() => {
    fetchMilestones();
    if (milestoneId && stateData) {
      fetchDetail(stateData.selectedStudentData.id, milestoneId);
    } else if (milestoneId) {
      fetchDetail(currentUser.id, milestoneId);
    } else {
      fetchDetail("", "");
    }
  }, [milestoneId, stateData]);
  const fetchDetail = (stId: string, id: string) => {
    axios
      .get(
        `/roadmap/milestones/detail?student_id=${stId || stuId}&milestone_id=${
          id || selectedCompetency.milestone_id
        }`,
      )
      .then((res) => {
        setMilestone(res.data.milestone);
        axios(
          `/student/version?student_id=${stId || stuId}&semester_name=${
            selectedCompetency?.semester_name || ""
          }&program_id=${userContext.user?.programs?.[0]?.id}`,
        )
          .then((res1) => {
            axios
              .get(
                `/competency/detail?competency_code=${
                  res?.data?.milestone.competency_card.competency_code ||
                  selectedCompetency.competency_code
                }&university_code=CMKL&curriculum_version=${
                  res1.data.version.curriculum_version
                }&semester_name=${
                  selectedCompetency?.semester_name ||
                  semesterContext.selectedSemester.label
                }`,
              )
              .then((res2) => setCompetencyDetail(res2.data.competency))
              .catch(() => {});
          })
          .catch(() => {});
      })
      .catch((err) => {
        axios
          .get(
            `/competency/detail?competency_code=${selectedCompetency.competency_code}&university_code=CMKL&curriculum_version=${selectedCompetency.curriculum_version}`,
          )
          .then((res) => setCompetencyDetail(res.data.competency))
          .catch((error) => {
            handleJWTError(error);
          });
        setMilestone(EmptyMilestoneType);
      });
  };
  const fetchMilestones = () => {
    axios
      .get(
        `/roadmap/milestones?student_id=${currentUser.id}&year=${semesterContext.selectedSemester?.year}&semester=${semesterContext.selectedSemester?.label}&program_name=${userContext.user?.programs?.[0]?.program_name || universityContext.selectedProgram?.short_name}`,
      )
      .then((res) => {
        const selectedMilestone = res.data.roadmaps[0].milestones.find(
          (v: any) => v.competency_card.id === selectedCompetency.id,
        );
        setMilestoneId(selectedMilestone.id);
      })
      .catch((err) => {
        handleJWTError(err);
      });
  };
  const redirectChild = () => {
    setIsModalOpen(false);
    // if (stateData) {
    //   const stData = stateData.selectedStudentData;
    //   navigate(roadmapViewData.url, {
    //     state: { selectedStudentData: stData },
    //   });
    // } else {
    //   navigate(roadmapViewData.url);
    // }
  };
  // const restore = () => {
  //   axios
  //     .post("/card/restore", {
  //       student_id: currentUser.id,
  //       card_id: selectedCompetency.id,
  //       semester_name: "Fall 2024",
  //     })
  //     .then((res) => {
  //       // setMessage("Restored card successfully");
  //       // if (res.data.card) {
  //       //   setMessageType('success');
  //       //   setMessageHeader('Success!');
  //       //   fetchParent();
  //       // } else {
  //       //   setMessageType('error');
  //       //   setMessageHeader('Error!');
  //       // }
  //       // setIsSnackbarOpen(true);
  //       // setOpen(false);
  //     })
  //     .catch(() => {
  //       // setMessageType('error');
  //       // setMessageHeader('Error!');
  //       // setMessage('Something went wrong');
  //       // setIsSnackbarOpen(true);
  //     });
  // };
  return (
    <>
      <FlexBox style={{ padding: "16px" }}>
        <FlexGrow>
          <StyledButton onClick={() => redirectChild()}>
            <NormalIcon
              name="angle-left"
              size={2.5}
              style={{ height: "20px", marginRight: "5px" }}
            />
            Back
          </StyledButton>
        </FlexGrow>
      </FlexBox>
      <FlexBox>
        <FlexGrow>
          <FlexBox
            alignItems="flex-start"
            style={{ background: "rgb(17 20 42)", padding: "16px" }}
          >
            <div>
              <CustomBlock
                backgroundColor={
                  milestone.graphics.iconbg ||
                  selectedCompetency.graphics.iconbg
                }
              >
                <StyledImg
                  src={
                    selectedCompetency.graphics.imgurl
                      ? process.env.REACT_APP_IMG_URL +
                        selectedCompetency.graphics.imgurl
                      : defaultImg
                  }
                  alt=""
                />
                <Icon
                  sx={{
                    color: "white",
                    padding: "6px",
                    background: selectedCompetency.graphics.iconbg,
                    borderRadius: "100px",
                    fontSize: "27px",
                    position: "absolute",
                    bottom: "90px",
                    right: "80px",
                    boxShadow: selectedCompetency.graphics.iconshadow,
                  }}
                >
                  {selectedCompetency.graphics.icon}
                </Icon>
                <StyledText fontWeight="700">
                  {milestone.title || selectedCompetency.title}
                </StyledText>
              </CustomBlock>
              {/* {tab === 2 && (
            <Button
              status={Status.blue}
              onClick={() => {
                restore();
              }}
              style={{ width: 200 }}
            >
              <Icon>restore</Icon>
              Restore
            </Button>
          )} */}
            </div>
            <FlexGrow>
              <FlexBox direction="column" alignItems="flex-start">
                <>
                  {/* <FlexGrow>
              <StyledText
                color="#E6E6E6"
                fontWeight="400"
                style={{ fontSize: '12px' }}>
                Engineering
              </StyledText>
            </FlexGrow> */}
                  <FlexGrow style={{ margin: 0 }}>
                    <StyledText
                      color="#FFFFFF"
                      fontWeight="700"
                      style={{ fontSize: "32px", marginRight: "5px" }}
                    >
                      [{selectedCompetency.competency_code}]
                    </StyledText>
                    <StyledText
                      color="#FFFFFF"
                      fontWeight="700"
                      style={{ fontSize: "32px" }}
                    >
                      {milestone.title || selectedCompetency.title}
                    </StyledText>
                  </FlexGrow>
                  <FlexGrow>
                    <StyledText
                      color="#9295AA"
                      fontWeight="400"
                      style={{ fontSize: "16px" }}
                    >
                      {milestone.description || selectedCompetency.description}
                    </StyledText>
                  </FlexGrow>
                  {(selectedCompetency.status === "Selected" ||
                    selectedCompetency.status === "In progress") &&
                    milestone.assessment_only && (
                      <FlexGrow>
                        <StyledText
                          color="#ffc107"
                          fontWeight="400"
                          style={{ fontSize: "16px" }}
                        >
                          Assessment Only
                        </StyledText>
                      </FlexGrow>
                    )}
                  <FlexGrow>
                    <StyledText
                      color="#FFFFFF"
                      fontWeight="400"
                      style={{ fontSize: "16px", paddingRight: "5px" }}
                    >
                      Staus: {selectedCompetency.status}{" "}
                      {(selectedCompetency.mastery_level_title) && (
                        <>- {selectedCompetency.mastery_level_title}</>
                      )}
                    </StyledText>
                  </FlexGrow>
                  <FlexGrow>
                    <StyledText
                      color="#FFFFFF"
                      fontWeight="400"
                      style={{ fontSize: "16px", paddingRight: "5px" }}
                    >
                      Credits: {selectedCompetency.credits}
                    </StyledText>
                    {milestone.required && (
                      <StyledText style={{ color: "#ffffff" }}>
                        -- REQUIRED
                      </StyledText>
                    )}
                  </FlexGrow>
                  <FlexGrow>
                    <StyledText
                      color="#FFFFFF"
                      fontWeight="400"
                      style={{ fontSize: "16px", paddingRight: "5px" }}
                    >
                      Version: {competencyDetail.display_version}
                    </StyledText>
                  </FlexGrow>
                  <FlexGrow>
                    <StyledText
                      color="#FFFFFF"
                      fontWeight="400"
                      style={{ fontSize: "16px", paddingRight: "5px" }}
                    >
                      Instructor:{" "}
                      {competencyDetail.semester_detail?.instructors ||
                        competencyDetail?.instructors ||
                        selectedCompetency.instructors}
                    </StyledText>
                  </FlexGrow>

                  {(selectedCompetency.status === "Selected" ||
                    selectedCompetency.status === "In progress") && (
                    <>
                      <FlexGrow>
                        <NormalIcon name="map-pin" />
                        <StyledText
                          color="#FFFFFF"
                          fontWeight="400"
                          style={{ fontSize: "16px" }}
                        >
                          Start date: {milestone.start_date}
                        </StyledText>
                      </FlexGrow>
                      <FlexGrow>
                        <NormalIcon name="hunting" />
                        <StyledText
                          color="#FFFFFF"
                          fontWeight="400"
                          style={{ fontSize: "16px" }}
                        >
                          Target completion date:{" "}
                          {milestone.target_completion_date}
                        </StyledText>

                        <Icon
                          sx={{
                            verticalAlign: "text-bottom",
                            fontSize: "21px",
                            color:
                              milestone.status === "Active"
                                ? "#3CC13B"
                                : milestone.status === "Planned"
                                ? "#ffd900c9"
                                : "#ffd900c9",
                            marginLeft: "32px",
                          }}
                        >
                          fiber_manual_record
                        </Icon>
                        <StyledText
                          color="#FFFFFF"
                          fontWeight="400"
                          style={{ fontSize: "16px" }}
                        >
                          {milestone.status}
                        </StyledText>
                      </FlexGrow>
                    </>
                  )}

                  {/* <div>
                <NormalIcon
                  color="#1990FF"
                  mr={1}
                  name="external-link-alt"
                />
                <ALink color="#1990FF">Link to resources</ALink>
              </div> */}
                </>
              </FlexBox>
            </FlexGrow>
          </FlexBox>
          <FlexBox>
            <FlexGrow>
              <StyledHr />
            </FlexGrow>
          </FlexBox>
          {competencyDetail?.semester_detail?.is_attendance_required && <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 152, 0, 0.1) 100%)",
                  border: "1px solid rgba(255, 193, 7, 0.3)",
                  borderLeft: "4px solid #ffc107",
                  borderRadius: 8,
                  padding: "12px 16px",
                  marginTop: 16,
                  marginBottom: 8,
                  boxShadow: "0 2px 8px rgba(255, 193, 7, 0.1)",
                }}
              >
                <Icon
                  title="Attendance Required"
                  sx={{
                    color: "#ffc107",
                    fontSize: "24px",
                    marginRight: "12px",
                    flexShrink: 0,
                  }}
                >
                  how_to_reg
                </Icon>
                <span
                  style={{
                    color: "#f57c00",
                    fontSize: "14px",
                    lineHeight: "1.5",
                    fontWeight: 500,
                  }}
                >
                  Students must attend lectures as defined by the instructor to earn this competency
                </span>
              </div>}
          <FlexBox>
            <FlexGrow style={{ padding: "20px" }}>
              <h3>Skills</h3>
            </FlexGrow>
          </FlexBox>
          <FlexBox>
            {selectedCompetency?.skills?.map((item: any, index: any) => (
              <FlexGrow
                style={{
                  maxWidth: isMobile ? "unset" : "48%",
                  minWidth: isMobile ? "100%" : "48%",
                  marginBottom: "16px",
                }}
              >
                {item.completed ? (
                  <SkillCompleted>
                    <FlexGrow style={{ width: "100%", flexGrow: 0 }}>
                      <FlexBox style={{ width: "100%" }}>
                        <FlexGrow>
                          {item.required ? (
                            <StyledText
                              status={TextStatus.muted}
                              textSize={TextSize.default}
                              fontWeight="normal"
                            >
                              Required
                            </StyledText>
                          ) : (
                            <StyledText
                              status={TextStatus.muted}
                              textSize={TextSize.default}
                              fontWeight="normal"
                            >
                              Optional
                            </StyledText>
                          )}
                        </FlexGrow>
                        <FlexGrow>
                          <RightAlign>
                            <StyledText
                              textSize={TextSize.paragraph}
                              fontWeight="600"
                            >
                              Completed
                              <NormalIcon name="check" />
                            </StyledText>
                          </RightAlign>
                        </FlexGrow>
                      </FlexBox>
                      <StyledHr />
                    </FlexGrow>
                    <FlexGrow style={{ width: "100%" }}>
                      <div>
                        <StyledText
                          textSize={TextSize.paragraph}
                          fontWeight="700"
                        >
                          [{item.skill_code}]
                        </StyledText>
                      </div>
                      <div>
                        <StyledText
                          textSize={TextSize.paragraph}
                          fontWeight="600"
                        >
                          {item.title}
                        </StyledText>
                      </div>
                      <div>
                        <StyledText
                          status={TextStatus.muted}
                          style={{ fontSize: "12px" }}
                          fontWeight="normal"
                        >
                          {item.description}
                        </StyledText>
                      </div>
                    </FlexGrow>
                    {item.assessment &&
                      item.assessment.assessment_time &&
                      item.assessment.assessment_time !== "" && (
                        <>
                          <StyledHr />
                          <FlexBox style={{ width: "100%" }}>
                            <FlexGrow></FlexGrow>
                            <FlexGrow>
                              <RightAlign>
                                <StyledText
                                  textSize={TextSize.paragraph}
                                  fontWeight="600"
                                >
                                  Result: {item.assessment.result}
                                </StyledText>
                              </RightAlign>
                            </FlexGrow>
                          </FlexBox>
                        </>
                      )}
                  </SkillCompleted>
                ) : (
                  <SkillOptional>
                    <FlexGrow style={{ width: "100%", flexGrow: 0 }}>
                      <div>
                        {item.required ? (
                          <StyledText
                            status={TextStatus.muted}
                            textSize={TextSize.default}
                            fontWeight="normal"
                          >
                            Required
                          </StyledText>
                        ) : (
                          <StyledText
                            status={TextStatus.muted}
                            textSize={TextSize.default}
                            fontWeight="normal"
                          >
                            Optional
                          </StyledText>
                        )}
                      </div>
                      <StyledHr />
                    </FlexGrow>
                    <FlexGrow style={{ width: "100%" }}>
                      <div>
                        <StyledText
                          textSize={TextSize.paragraph}
                          fontWeight="700"
                        >
                          [{item.skill_code}]
                        </StyledText>
                      </div>
                      <div>
                        <StyledText
                          textSize={TextSize.paragraph}
                          fontWeight="600"
                        >
                          {item.title}
                        </StyledText>
                      </div>
                      <div>
                        <StyledText
                          status={TextStatus.muted}
                          style={{ fontSize: "12px" }}
                          fontWeight="normal"
                        >
                          {item.description}
                        </StyledText>
                      </div>
                    </FlexGrow>
                    {item.assessment &&
                      item.assessment.assessment_time &&
                      item.assessment.assessment_time !== "" && (
                        <>
                          <StyledHr />
                          <FlexBox style={{ width: "100%" }}>
                            <FlexGrow></FlexGrow>
                            <FlexGrow>
                              <RightAlign>
                                <StyledText
                                  textSize={TextSize.paragraph}
                                  fontWeight="600"
                                >
                                  Result: {item.assessment.result}
                                </StyledText>
                              </RightAlign>
                            </FlexGrow>
                          </FlexBox>
                        </>
                      )}
                  </SkillOptional>
                )}
              </FlexGrow>
            ))}
          </FlexBox>
        </FlexGrow>
      </FlexBox>
    </>
  );
}
export default CompetencyDetail;
